import { render, staticRenderFns } from "./censor.vue?vue&type=template&id=464da17c&"
import script from "./censor.vue?vue&type=script&lang=js&"
export * from "./censor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports